import {
    ISheetAPI,
    ISheetContext,
    ISheetValue, ISurfaceContext,
    ITimerContext,
    SheetType,
} from '@mintdata/mint-kit/api/functions/SheetAPI';
import {SheetContextImpl} from '@mintdata-wsp/common/controllers/spreadsheet/formula/functionAPIs/SheetContextImpl';
import {SurfaceContextImpl} from '@mintdata-wsp/common/controllers/spreadsheet/formula/functionAPIs/SurfaceContextImpl';
import bind from 'bind-decorator';

export class SheetAPIImpl implements ISheetAPI, ISheetValue
{
    private readonly _sheetContext:ISheetContext;
    private readonly _timerContext:ITimerContext;
    private readonly _surfaceContext:SurfaceContextImpl;

    constructor(sheetContext:SheetContextImpl,
                timerContext: ITimerContext,
                surfaceContext:SurfaceContextImpl)
    {
        this._sheetContext = sheetContext;
        this._timerContext = timerContext;
        this._surfaceContext = surfaceContext;
    }

    @bind
    getSheetContext():ISheetContext
    {
        return this._sheetContext;
    }

    @bind
    getTimerContext():ITimerContext
    {
        return this._timerContext;
    }

    @bind
    getSurfaceContext(): ISurfaceContext
    {
        return this._surfaceContext;
    }

    getType():SheetType
    {
        return SheetType.SheetAPI;
    }

    public toString():string
    {
        return `[ISheetAPI]`;
    }
}
